import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import store from "./store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import LoadingSpinner from "./components/LoadingSpinner";
import * as ServiceWorkerRegistration from "./ServiceWorkerRegistration";
import EditSettings from "./pages/EditSettings";
import FeatureConfigs from "./pages/FeatureConfigs";
import EditfeatureConfig from "./pages/EditFeatueConfig";
import CreditLogs from "./pages/CreditLogs";
import CreditInfo from "./pages/CreditReport";
import CreditEnquiry from "./pages/CreditEnquiry";
import ExperianDetails from "./pages/ExperianDetails";
import Secrets from "./pages/Secrets";
import AddSecret from "./pages/AddSecret";
import EditSecret from "./pages/EditSecret";
import AccountAggregatorDetails from "./pages/AccountAggregatorDetails";
import BankStatementPage from "./pages/BankStatementPage";
import PendingLoan from "./pages/PendingLoan";
import ServiceArea from "./pages/ServiceArea";
import NotificationTemplates from "./pages/NotificationTemplates";
import AddLoanNote from "./pages/AddLoanNote";
import ViewLoanNote from "./components/ViewLoanNote";
import EditNotificationTemplate from "./pages/EditNotificationTemplate";
import CashfreeCheckoutPage from "./pages/CashfreeCheckoutPage";
import ReviewLoans from "./pages/ReviewLoan";
import DisbursedLoans from "./pages/DisbursedLoans";
import NotificationComponent from "./components/NotificationComponent";
import LoanTermsManager from "./pages/LoanTermsManager";
import ApiVersions from "./pages/ApiVersions";
import VersionForm from "./components/VersionForm";
import PaymentList from "./pages/PaymentList";
import ApiLogsPage from "./pages/ApiLogsPage";
import Statement from "./components/BankAnalyserStatement/Statement";
import AnalyserStatement from "./components/BankAnalyserStatement/AnalyserStatement";
import WebhookLogsTable from "./Table/WebhookLogsTable";
import WebhookLogs from "./pages/WebhookLogs";
import EmiList from "./pages/EmiListing";

const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Customers = lazy(() => import("./pages/Customers"));
const Loan = lazy(() => import("./pages/Loan"));
const LoanApplication = lazy(() => import("./pages/LoanApplication"));
const SettingsList = lazy(() => import("./pages/Settings"));
const Roles = lazy(() => import("./pages/Roles"));
const CustomerDetails = lazy(() => import("./pages/CustomerDetail"));
const AdminListing = lazy(() => import("./pages/Admin"));
const LoanDetails = lazy(() => import("./pages/LoanInfo"));

const PermissionManagement = lazy(() => import("./pages/PermissionManagement"));

const DynamicTitleLayout = lazy(() =>
  import("./components/DynamicTitlelayout")
);

// Loading component

const App = () => {
  useEffect(() => {
    // Add version meta tag
    const metaTag = document.createElement("meta");
    metaTag.name = "app-version";
    metaTag.content = process.env.REACT_APP_VERSION || Date.now().toString();
    document.head.appendChild(metaTag);

    // Register service worker
    ServiceWorkerRegistration.register({
      onUpdate: (registration) => {
        const confirmReload = window.confirm(
          "A new version of the app is available. Reload now?"
        );
        if (confirmReload) {
          window.location.reload();
        }
      },
    });
  }, []);

  return (
    <Provider store={store}>
      
      <AuthProvider>
      {/* <NotificationComponent /> */}
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/login" element={<Login />} />
          
            <Route
    path="/cashfree"
    element={
      <Suspense fallback={<LoadingSpinner />}>
        <CashfreeCheckoutPage />
      </Suspense>
    }
  />
            <Route element={<DynamicTitleLayout />}>
              <Route
                path="/dashboard"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <Dashboard />
                  </Suspense>
                }
              />
                 <Route
                path="/loanTerms"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <LoanTermsManager />
                  </Suspense>
                }
              />
              <Route
                path="/customers"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <Customers />
                  </Suspense>
                }
              />
              <Route
                path="/admin"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <AdminListing />
                  </Suspense>
                }
              />
              <Route
                path="/customers/view/:id"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <CustomerDetails />
                  </Suspense>
                }
              />
              <Route path="/creditLogs" element={<CreditLogs />} />
              <Route path="/creditLogs/creditReport" element={<CreditInfo />} />
              <Route
                path="/creditLogs/CreditEnquiry/:id"
                element={<CreditEnquiry />}
              />
              <Route
                path="/creditLogs/creditReport/:id"
                element={<ExperianDetails />}
              />

              <Route path="/apiLogs" element={<ApiLogsPage />} />
              <Route path="/webhookLogs/:id" element={<WebhookLogs/>} />

              <Route path="/apiVersions" element={<ApiVersions />} />
              <Route path="/apiVersions/create" element={<VersionForm />} />
              <Route path="/payments" element={<PaymentList />} />
              <Route path="/analyserStatement" element={<AnalyserStatement />} />
        
        {/* Edit API version */}
        <Route path="/apiVersions/edit/:id" element={<VersionForm />} />
              <Route
                path="/roles"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <Roles />
                  </Suspense>
                }
              />
              <Route
                path="/roles/:roleId"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <PermissionManagement />
                  </Suspense>
                }
              />
              <Route
                path="/loans"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <Loan />
                  </Suspense>
                }
              />
               <Route
                path="/pendingLoans"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <PendingLoan />
                  </Suspense>
                }
              />
                 <Route
                path="/reviewLoans"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <ReviewLoans />
                  </Suspense>
                }
              />
                     <Route
                path="/disbursedLoans"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <DisbursedLoans />
                  </Suspense>
                }
              />
              <Route
                path="/loans/:id"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <LoanDetails />
                  </Suspense>
                }
              />
                    <Route
                path="/accountAggregator/:id"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <AccountAggregatorDetails />
                  </Suspense>
                }
              />
                <Route
                path="/accountAggregator/banks/:id"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <BankStatementPage />
                  </Suspense>
                }
              />
              <Route
                path="/loan-applications"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <LoanApplication />
                  </Suspense>
                }
              />
              <Route path="/settings" element={<SettingsList />} />
              <Route path="/secrets" element={<Secrets />} />
              <Route path="/secrets/add" element={<AddSecret />} />
              <Route path="/secrets/:id" element={<EditSecret />} />

              <Route path="/featureConfigs" element={<FeatureConfigs />} />
              <Route
                path="/featureConfigs/:configId"
                element={<EditfeatureConfig />}
              />

              <Route
                path="/settings/:settingsId"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <EditSettings />
                  </Suspense>
                }
              />
                  <Route
                path="/serviceArea"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <ServiceArea />
                  </Suspense>
                }
              />

<Route
                path="/loan/notes/add/:loanId"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <AddLoanNote />
                  </Suspense>
                }
              />
              <Route
                path="/loan/notes/view/:id"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <ViewLoanNote />
                  </Suspense>
                }
              />
                 <Route
                path="/notifficationTemplate"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <NotificationTemplates />
                  </Suspense>
                }
              />
                   <Route
                path="/emiList"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <EmiList />
                  </Suspense>
                }
              />
                  <Route
                path="/notifficationTemplate/:id"
                element={
                  <Suspense fallback={<LoadingSpinner />}>
                    <EditNotificationTemplate />
                  </Suspense>
                }
              />
            </Route>
            

            {/* Catch-all route for redirects */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </Provider>
  );
};

export default App;
